import { useRouter }                        from "next/router";
import { useCallback, useEffect, useState } from "react";

import { useGetCreatorPlusStatus, useGetLoggedIn, useGetProfileData, useGetUserRoles } from "_common/hooks/auth";
import { getStreamsToBeDeleted }                                                       from "_services/api/creator-plus";

import { tabList } from "../utils";

import Presentation from "./presentation";

const TabContent = ( {
	activeTab,
	isDepleted,
	isLoading,
	list,
	fetchMore,
	updateDeletedPost
} ) => {
	const [ streamsToDelete, setStreamsToDelete ]   = useState ( [] );
	const [ totalNoOfStreams, setTotalNoOfStreams ] = useState ( 0 );
	const [ deletionTime, setDeletionTime ]         = useState ( null );
	const [ isLoadingStreams, setIsLoadingStreams ] = useState ( true );
	const router                                    = useRouter ();
	const { id: userId }                            = router.query;
	const userRoles                                 = useGetUserRoles ();
	const isLoggedIn                                = useGetLoggedIn ();
	const myProfile                                 = useGetProfileData ();

	const isCreatorPlus = useGetCreatorPlusStatus ();

	const checkOwnProfile = () => {
		return userId === myProfile?.id?.toString ();
	};

	const fetchStreamsToBeDeleted = useCallback ( async () => {
		try {
			setIsLoadingStreams ( true );

			const response = await getStreamsToBeDeleted ( {
				pageNo   : 1,
				pageSize : 20
			} );

			setStreamsToDelete ( response?.streams || [] );
			setTotalNoOfStreams ( response?.totalNoOfStreams || 0 );
			setDeletionTime ( response?.deletionTime || null );
		} catch ( err ) {
			// Silently fail - don't show error if API fails
			setStreamsToDelete ( [] );
			setTotalNoOfStreams ( 0 );
			setDeletionTime ( null );
		} finally {
			setIsLoadingStreams ( false );
		}
	}, [] );

	useEffect ( () => {
		// Don't do anything if userRoles is still loading (undefined)
		// if ( userRoles === undefined )
		//   return;

		if ( isLoggedIn && checkOwnProfile () && activeTab === tabList[0].value && !isCreatorPlus ) {
			fetchStreamsToBeDeleted ();
		} else {
			// If user is creator-plus, set empty array and stop loading
			setStreamsToDelete ( [] );
			setTotalNoOfStreams ( 0 );
			setDeletionTime ( null );
			setIsLoadingStreams ( false );
		}
	}, [ activeTab, isCreatorPlus, userRoles, fetchStreamsToBeDeleted ] );

	return (
		<Presentation
			activeTab         = { activeTab }
			deletionTime      = { deletionTime }
			fetchMore         = { fetchMore }
			isDepleted        = { isDepleted }
			isLoading         = { isLoading }
			isLoadingStreams  = { isLoadingStreams }
			list              = { list }
			streamsToDelete   = { streamsToDelete }
			totalNoOfStreams  = { totalNoOfStreams }
			updateDeletedPost = { updateDeletedPost }
		/>
	);
};

export default TabContent;